import React from 'react';
import { useEffect, useState, useRef } from "react";
import styled from 'styled-components';
import NavButton from '../../homepage/header-banner/TopNavButton';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Grid } from '@mui/material';
//import './sidebar.css';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute";
import CardWrap from '../components/CardWrapper';
// import config from '../components/config';
import '../../container/Box/Components/Box-Style.css'
import Sidebar from '../../container/Sidebar/Sidebar';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';

// Titlecloudcompute
function SimpleUrl() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Simple-Url-Shortener - Serverless Application - 프라이빗 클라우드';
    }, []);
    return (
        <div className='App'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            {/* {Banner("Hanbiro", "Microservice architecture")} */}
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Simple-Url-Shortener")} */}
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">Simple URL Shortener 란</p></BoxTitle>

                            <BoxText  >
                                <p class="typo-14">많은 문자와 기호, 숫자가 포함된 긴 웹주소를 짧은 URL 로 제공 : PURLs 사용 </p>
                                <p class="typo-14">(예) <u>abc.vora.net/desk/marketing/survey.html?id=a3bc65cd</u> </p>
                                <p class="typo-14">- 기본 도메인 사용시 =&gt; sus.so/aB2b3Aza </p>
                                <p class="typo-14">- 자사 도메인 사용시 =&gt; 자사도메인/aB2b3Aza </p>
                                <br></br>
                                <p class="typo-14">짧고 읽기 쉬운 URL 로 제공 : 일반 웹사이트 사용 (이전 사이트 URL 인식가능). </p>
                                <p class="typo-14">- 기본 도메인 사용시 =&gt; sus.so/자사브랜드명/자사고유단어(help, sales, marketing 등) </p>
                                <p class="typo-14">- 자사 도메인 사용시 =&gt; 자사도메인/자사고유단어(help, sales, marketing 등) </p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <BoxTitle className='sub-title'><p class="typo-21 typo-medium typo-black">PURLs (Personalized URLs)</p></BoxTitle>
                            <BoxText  >
                                <p class="typo-14">- 마케팅 캠페인에서 각 대상자별로 웹 URL 주소와 컨덴츠를 제공. </p>
                                <p class="typo-14">- 각각의 PURL 은 개인화된 유일한 웹사이트 링크가 가능. </p>
                                <p class="typo-14">- 개인화된 텍스트, 이미지, 제공품, 설문조사등이 진행될때 마케팅담당자는 온라인 응답이나 참여에 대해서 추적 가능.</p>
                            </BoxText>
                        </BoxContent>
                        <DividerComponent />
                        {/* {CardWrap("<p class='typo-21 typo-medium typo-black'>Email / SMS 마케팅시 단축 URL 사용 예</p>", "", "", "https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg")} */}
                        <BoxContent>
                            <BoxText ><p class="typo-21-sm typo-medium typo-black">Email / SMS 마케팅시 단축 URL 사용 예</p></BoxText>
                            <ImageWrap src="https://hanbiro.com/cloud/library2/simple-url-shortener/simple-url-shortener-1.svg"></ImageWrap>
                        </BoxContent>
                        {/*CardWrap("• 가격",config.tb8_header,config.tb8_content)*/}

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            {/* <Cloudconsult /> */}
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    );
};

const BoxTitle = styled.div`
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;
`

const BoxSubText = styled.div`
  margin-left: 7%;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`
export default SimpleUrl;